import React from 'react';
import { BaseButton } from '@repo/common';

const STEP_LABELS = [
  'Profile',
  'Education',
  'Experience',
  'Skills',
  'Activity',
  'Link',
];

/**
 * 모바일 하단 고정 버튼 바.
 * - 좌: Back (이전 스텝 or 페이지 이탈)
 * - 우: Next: {다음 섹션명} → 마지막 스텝에서는 Save
 *
 * @param currentStep  현재 스텝 index (0~5)
 * @param totalSteps   전체 스텝 수 (기본 6)
 * @param onBack       Back 클릭 핸들러
 * @param onNext       Next 클릭 핸들러
 * @param onSave       마지막 스텝 Save 클릭 핸들러
 * @param disabled     Next/Save 비활성화 여부 (선택)
 */
const MobileBottomButton = ({
  currentStep = 0,
  totalSteps = 6,
  onBack,
  onNext,
  onSave,
  disabled = false,
}) => {
  const isLastStep = currentStep >= totalSteps - 1;
  const nextLabel = isLastStep
    ? 'Finish'
    : `Next: ${STEP_LABELS[currentStep + 1] ?? ''}`;

  const handleRightClick = () => {
    if (disabled) return;
    if (isLastStep) {
      onSave?.();
    } else {
      onNext?.();
    }
  };

  return (
    <div
      className='
        fixed bottom-0 left-0 right-0 z-40
        bg-grayscale-gray00
        border-t border-grayscale-gray02
        p-4 pt-3 w-full
      '
    >
      <div className='flex items-center gap-3'>
        <BaseButton onClick={onBack} type='text' size='l' hideIcon>
          Back
        </BaseButton>

        <BaseButton
          onClick={handleRightClick}
          isDisabled={disabled}
          size='l'
          hideIcon
          width='100%'
        >
          {nextLabel}
        </BaseButton>
      </div>
    </div>
  );
};

export default MobileBottomButton;
